import React from 'react';
import { graphql } from 'react-apollo';
import { GET_LAYOUT_TYPE } from "../../../queries/layout_type";
import MenuItem from '@material-ui/core/MenuItem';
import { InputLabel, Select } from '@material-ui/core';

const layoutType = ({ form: { form }, layoutTypeId:{ layoutTypeId }, onChange: myChange, data: { layoutType, loading, error }}) => {
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  const handleChange = (e) => {
      if(myChange){
        myChange(e.target.value);
      }
  }
  return (
    <>
    {
    form.getFieldDecorator('layoutTypeId',
           {
            initialValue: (layoutTypeId || '')
          })(<>
            <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Layout Type</InputLabel>
            <Select fullWidth id="layoutTypeId"
              labelId="select-Settings-layoutType"
              onChange={handleChange} value={layoutTypeId}
            >
              { layoutType.map(item => <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>) }
            </Select></>
          )}
    </>
        
  );
}
export const LayoutTypesLookup = graphql(GET_LAYOUT_TYPE)((layoutType));